import type { CustomIconProps } from '../CustomIcon';

export const RejectIcon = ({
  color,
  size = 24,
  secondaryColor,
  ternaryColor,
  solid,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M18 6L6 18'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6 6L18 18'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
